export default __webpack_public_path__ + "static/blog-ux-1f2778e6012efa8e79313e278c93be67.png";